import {ArtfactKind} from '@mrp-brasil/nick-data-commons';
import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';

@HookClass('context')
export class ContextHook extends BaseHook {

    @Hook('a31fabf2-1c2d-4f2f-b1e2-793a54d3bdfa')
    public currentSystem(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.context.system
            .pipe(map((system: any) => {
                const outputArtifact = new NickProcessArtfact();
                outputArtifact.kind = ArtfactKind.ANY;
                outputArtifact.object = system;
                return outputArtifact;
            }));
    }
}
